import { merge } from 'lodash';
import { TextStyleTransformer } from '../text-style-transformer.js';
import createCustomStyles from './generators/customStyles.js';
import createPalette from './generators/palette.js';
import createTypography from './generators/typography.js';
import { h as buildCssVarsObj } from '../themeUtils-15fd38f0.js';
import '../utils-c6ecea9a.js';
import 'ricos-content/libs/utils';
import '../textual-theme/custom-styles.js';
import '../textual-theme/empty-custom-style.js';
import '../textual-theme/custom-style.js';
import '../document-style/node-style.js';
import '../document-style/text-style.js';
import '../decorations/decorations.js';
import 'ricos-schema';
import '../decorations/bold-decoration.js';
import '../decorations/empty-decoration.js';
import '../decorations/color-decoration.js';
import '../decorations/font-size-decoration.js';
import '../decorations/italic-decoration.js';
import './generators/identifiers.js';
import './palettes/presets.js';
import './palettes/wixPaletteUtils.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const buildThemeCssVars = (theme, documentStyle) => {
  const documentStyleTheme = TextStyleTransformer.fromDocumentStyle(documentStyle).toTheme();
  const mergedTheme = merge({}, theme, documentStyleTheme);
  const { palette, paletteConfig, typography, customStyles, settingsStyles, nativeStyle } = mergedTheme;
  const { paletteVarsObject } = createPalette(palette, paletteConfig);
  const typographyVarsObject = createTypography(typography);
  const customsVarsObject = createCustomStyles({
    customStyles,
    settingsStyles,
    nativeStyle
  });
  const varsObj = __spreadValues(__spreadValues(__spreadValues({}, paletteVarsObject), typographyVarsObject), customsVarsObject);
  return buildCssVarsObj(varsObj);
};

export { buildThemeCssVars };
//# sourceMappingURL=build-theme-css-vars.js.map
